import React from "react";
import "react-phone-input-2/lib/style.css";
import logo from "../../assets/logo.png";

const FInishInscriptionPage = () => {
  // const navigate = useNavigate();

  return (
    <>
      <div className="  bg-white highShadow  py-8 px-8 rounded-lg min-w-[94%] md:min-w-max md:w-1/3 border border-gray-200 mx-4">
        <div className="flex flex-col gap-1">
          <h1 className="LoginTtitle self-center">Congratulations</h1>
        </div>
        <div className="flex flex-col gap-1">
          <h1 className="LoginTtitle self-center">
            we recieved your inscription
          </h1>
          <h1 className="text-primaryColor font-semibold self-center">
            Welcome to our online English course!
          </h1>
          <h1 className="text-primaryColor font-semibold self-center">
            One of our team members will be in touch shortly to confirm your
            enrollment and provide the next steps.
          </h1>
          <h1 className="text-primaryColor font-semibold self-center">
            Get ready to learn, grow, and succeed!
          </h1>
          <img
            src={logo}
            alt="finishInscription"
            className="self-center h-40"
          />
        </div>
      </div>
    </>
  );
};
export default FInishInscriptionPage;
